var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAds2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "advertising_4672104 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.296 35.8042H36.1103C35.8998 35.8041 35.6944 35.868 35.5212 35.9875C35.348 36.1071 35.2153 36.2765 35.1408 36.4733L33.668 40.3655C29.9463 39.1025 26.565 37.0001 23.7859 34.221C21.0068 31.4419 18.9044 28.0607 17.6414 24.3389L21.5336 22.8661C21.7304 22.7916 21.8999 22.6589 22.0194 22.4857C22.1389 22.3126 22.2028 22.1071 22.2027 21.8966V10.6819C22.2049 9.96164 22.064 9.24809 21.788 8.58276C21.5121 7.91742 21.1066 7.31356 20.5953 6.80629C20.0697 6.28271 19.4451 5.86893 18.7581 5.58906C18.071 5.30918 17.3351 5.16879 16.5933 5.17607H16.1334C13.2623 5.155 10.4993 6.2702 8.44729 8.2784C6.39524 10.2866 5.22063 13.0248 5.17969 15.8957V16.2893C5.32146 25.9341 9.21619 35.144 16.0372 41.9643C22.8583 48.7846 32.0686 52.6783 41.7135 52.8189H42.0843C44.96 52.7802 47.7031 51.6027 49.7121 49.5448C51.7212 47.4868 52.8323 44.7162 52.8018 41.8404V41.308C52.7991 39.8488 52.2181 38.4502 51.1861 37.4185C50.154 36.3869 48.7552 35.8064 47.296 35.8042ZM50.7304 41.8404C50.7614 44.167 49.8688 46.4111 48.2481 48.0807C46.6273 49.7503 44.4108 50.7093 42.0843 50.7475H41.73C32.627 50.6159 23.9338 46.9413 17.4961 40.504C11.0584 34.0667 7.38329 25.3737 7.25112 16.2706V15.8957C7.29146 13.5733 8.2482 11.361 9.91281 9.74101C11.5774 8.12103 13.8149 7.22474 16.1375 7.2475H16.5912C17.0611 7.24337 17.5271 7.33282 17.962 7.51064C18.397 7.68846 18.7921 7.95109 19.1245 8.28322C19.4427 8.59832 19.6948 8.97364 19.8662 9.38727C20.0376 9.8009 20.1249 10.2445 20.123 10.6923V21.1924L15.9801 22.7604C15.7354 22.854 15.5352 23.0368 15.4199 23.272C15.3046 23.5072 15.2827 23.7774 15.3587 24.0281C16.6726 28.4321 19.0621 32.4398 22.3117 35.6898C25.5613 38.9397 29.5687 41.3296 33.9725 42.6441C34.2233 42.72 34.4935 42.6981 34.7287 42.5828C34.9639 42.4675 35.1467 42.2674 35.2403 42.0226L36.8083 37.8798H47.2877C48.1982 37.8809 49.0711 38.2431 49.715 38.8869C50.3588 39.5308 50.721 40.4037 50.7221 41.3142L50.7304 41.8404Z",
    fill: "url(#paint0_linear_1461_14153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.9996 28.748C27.9615 28.9007 27.9587 29.06 27.9914 29.2139C28.0241 29.3677 28.0914 29.5122 28.1883 29.6362C28.2851 29.7601 28.4089 29.8604 28.5503 29.9294C28.6917 29.9984 28.8469 30.0343 29.0042 30.0344C29.0887 30.0343 29.1729 30.0238 29.2549 30.0033L34.6945 28.6444C37.331 30.0077 40.3681 30.3833 43.2573 29.7033C46.1465 29.0234 48.6973 27.3327 50.4491 24.9366C52.2009 22.5406 53.0382 19.5971 52.8097 16.6378C52.5813 13.6784 51.3021 10.8983 49.2033 8.79955C47.1046 6.70076 44.3245 5.42163 41.3651 5.19317C38.4058 4.96471 35.4623 5.80198 33.0663 7.55377C30.6702 9.30556 28.9795 11.8564 28.2996 14.7456C27.6196 17.6348 27.9952 20.6719 29.3585 23.3084L27.9996 28.748ZM40.3971 7.24865C41.9806 7.24747 43.5433 7.6094 44.9651 8.30663C46.3869 9.00385 47.6298 10.0178 48.5984 11.2705C49.5671 12.5233 50.2355 13.9814 50.5524 15.5329C50.8694 17.0844 50.8263 18.6879 50.4266 20.2202C50.0269 21.7524 49.2811 23.1726 48.2467 24.3716C47.2123 25.5705 45.9167 26.5163 44.4596 27.1363C43.0024 27.7562 41.4226 28.0337 39.8414 27.9476C38.2602 27.8614 36.7198 27.4139 35.3387 26.6393C35.1839 26.5517 35.009 26.506 34.8312 26.5067C34.7467 26.5068 34.6625 26.5173 34.5805 26.5378L30.4273 27.5735L31.463 23.4203C31.5272 23.1639 31.4909 22.8927 31.3615 22.6622C30.4799 21.0861 30.0257 19.307 30.0439 17.5012C30.0622 15.6955 30.5522 13.9259 31.4655 12.368C32.3787 10.8101 33.6834 9.51801 35.2502 8.62001C36.8169 7.72201 38.5912 7.24925 40.3971 7.24865Z",
    fill: "url(#paint1_linear_1461_14153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.1763 21.7506C34.451 21.7506 34.7145 21.6414 34.9087 21.4472C35.1029 21.253 35.2121 20.9895 35.2121 20.7148V20.197H37.8013V20.7148C37.8013 20.9895 37.9105 21.253 38.1047 21.4472C38.2989 21.6414 38.5624 21.7506 38.8371 21.7506C39.1117 21.7506 39.3752 21.6414 39.5694 21.4472C39.7636 21.253 39.8728 20.9895 39.8728 20.7148V16.8309C39.8728 15.9382 39.5181 15.082 38.8869 14.4507C38.2556 13.8195 37.3994 13.4648 36.5067 13.4648C35.614 13.4648 34.7578 13.8195 34.1265 14.4507C33.4953 15.082 33.1406 15.9382 33.1406 16.8309V20.7148C33.1406 20.9895 33.2497 21.253 33.444 21.4472C33.6382 21.6414 33.9017 21.7506 34.1763 21.7506ZM36.5067 15.5363C36.8501 15.5363 37.1794 15.6727 37.4221 15.9155C37.6649 16.1583 37.8013 16.4876 37.8013 16.8309V18.1256H35.2121V16.8309C35.2121 16.4876 35.3485 16.1583 35.5912 15.9155C35.834 15.6727 36.1633 15.5363 36.5067 15.5363Z",
    fill: "url(#paint2_linear_1461_14153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.9498 21.7506H43.5033C44.6021 21.7506 45.6559 21.3141 46.4328 20.5371C47.2097 19.7602 47.6462 18.7065 47.6462 17.6077C47.6462 16.5089 47.2097 15.4552 46.4328 14.6783C45.6559 13.9013 44.6021 13.4648 43.5033 13.4648H41.9498C41.6751 13.4648 41.4116 13.574 41.2174 13.7682C41.0232 13.9624 40.9141 14.2259 40.9141 14.5006V20.7148C40.9141 20.9895 41.0232 21.253 41.2174 21.4472C41.4116 21.6414 41.6751 21.7506 41.9498 21.7506ZM42.9855 15.5363H43.5033C44.0527 15.5363 44.5796 15.7545 44.9681 16.143C45.3565 16.5314 45.5748 17.0583 45.5748 17.6077C45.5748 18.1571 45.3565 18.684 44.9681 19.0724C44.5796 19.4609 44.0527 19.6791 43.5033 19.6791H42.9855V15.5363Z",
    fill: "url(#paint3_linear_1461_14153)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1461_14153",
    x1: 3.38997,
    y1: 57.6682,
    x2: 53.125,
    y2: 1.96329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF33B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FEE72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#FED51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FDCA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FDC70C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F3903F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#ED683C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E93E3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1461_14153",
    x1: 4.07873,
    y1: 58.2824,
    x2: 53.8158,
    y2: 2.57758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF33B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FEE72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#FED51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FDCA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FDC70C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F3903F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#ED683C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E93E3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1461_14153",
    x1: 2.27012,
    y1: 56.6748,
    x2: 52.0072,
    y2: 0.969981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF33B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FEE72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#FED51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FDCA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FDC70C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F3903F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#ED683C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E93E3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1461_14153",
    x1: 5.76192,
    y1: 59.7861,
    x2: 55.4969,
    y2: 4.08127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF33B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FEE72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#FED51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FDCA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FDC70C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F3903F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#ED683C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E93E3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds2);
export default __webpack_public_path__ + "static/media/ads2.28561a574ab1a396a8afb49a3d882c6a.svg";
export { ForwardRef as ReactComponent };